import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES, LOCALE_NAMES, changeLanguage, type SupportedLocale } from '../i18n';

export function LanguageSelector() {
  const { i18n, t } = useTranslation();
  const currentLocale = i18n.language as SupportedLocale;

  return (
    <div className="language-selector">
      <select
        className="language-select"
        value={currentLocale}
        onChange={(e) => changeLanguage(e.target.value as SupportedLocale)}
        aria-label={t('language.select')}
      >
        {SUPPORTED_LOCALES.map((locale) => (
          <option key={locale} value={locale}>
            {LOCALE_NAMES[locale]}
          </option>
        ))}
      </select>
    </div>
  );
}
